"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CommunicationSelectedMethodCall = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/CommunicationSelectedMethodCall"));

var _communicationMethodTypes = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _MeetingPrompt = require("ui-addon-upgrades/_core/communicationMethods/MeetingPrompt");

var _meetingHelpers = require("ui-addon-upgrades/_core/common/api/meetingHelpers");

var _EmailModal = _interopRequireDefault(require("../communicationMethods/EmailModal"));

var MEETING = _communicationMethodTypes.default.MEETING,
    CALL = _communicationMethodTypes.default.CALL,
    EMAIL = _communicationMethodTypes.default.EMAIL;

var _prompt = (0, _Promptable.default)(_EmailModal.default);

var EmailPrompt = function EmailPrompt(propsToPass) {
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};

var _default = [{
  communicationKey: CALL,
  image: 'calling-small',
  SelectedMethodComponent: _CommunicationSelectedMethodCall.default,
  onClick: function onClick(propsToPass) {
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked contact sales with phone call'
    }, propsToPass.upgradeData));
  }
}, {
  communicationKey: MEETING,
  image: 'meetings-small',
  SelectedMethodComponent: null,
  onClick: function onClick(propsToPass) {
    var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var upgradeData = propsToPass.upgradeData,
        onCancel = propsToPass.onCancel;
    var repInfo = upgradeData.repInfo;
    var linkBase = repInfo.link;
    var meetingLink = linkBase + "?" + (0, _meetingHelpers.getInlineMeetingParams)(upgradeData);
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked contact sales with meeting'
    }, upgradeData));
    (0, _MeetingPrompt.MeetingPrompt)({
      meetingLink: meetingLink,
      upgradeData: upgradeData,
      onCancel: onCancel
    });
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'shown booking page',
      meetingLink: linkBase
    }, upgradeData));
    onClose();
  }
}, {
  communicationKey: EMAIL,
  image: 'successfully-connected-email',
  SelectedMethodComponent: null,
  onClick: function onClick(propsToPass) {
    var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var upgradeData = propsToPass.upgradeData,
        onCancel = propsToPass.onCancel;
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked send email'
    }, upgradeData));
    EmailPrompt({
      upgradeData: upgradeData,
      onCancel: onCancel
    });
    onClose();
  }
}];
exports.default = _default;
module.exports = exports.default;